import React from 'react';
import classNames from 'classnames';
import { WidgetViewState } from '@/components/widget/WidgetOpeningManager';
import { useMessagesStore } from '@/hooks/useMessagesStore';
import { useWidgetConfig } from '@/hooks/useWidgetConfig';
import { useWidgetUIStore } from '@/hooks/useWidgetUIStore';
import WidgetIcon from './WidgetIcon';

const WidgetButton: React.FC = () => {
  const { isWidgetVisible, actions } = useWidgetUIStore();
  const { config: widgetConfig } = useWidgetConfig();
  const { hasUnreadAgentMessages } = useMessagesStore();

  const handleClick = () => {
    // If widget is currently visible, minimize it; otherwise open to appropriate view
    if (isWidgetVisible()) {
      actions.setCurrentView(WidgetViewState.MINIMIZED);
    } else {
      // V2: Default to landing page since defaultLandingPage was removed
      actions.setCurrentView(WidgetViewState.LANDING_PAGE);
    }
  };

  if (!widgetConfig) return null;

  const isCurrentlyVisible = isWidgetVisible();

  return (
    <button
      onClick={handleClick}
      className={classNames(
        'sf:absolute sf:bottom-4 sf:right-4 sf:group sf:bg-widget-button-color sf:rounded-full sf:shadow-lg sf:flex sf:items-center sf:justify-center sf:transition-all sf:duration-300 sf:ease-in-out sf:hover:shadow-xl sf:hover:scale-110 sf:focus:outline-none sf:focus:ring-4 sf:focus:ring-blue-20 sf:focus:ring-opacity-50 sf:cursor-pointer',
        'sf:sm:bottom-0 sf:sm:right-0',
      )}
      aria-label={isCurrentlyVisible ? 'Close chat widget' : 'Open chat widget'}
      aria-expanded={isCurrentlyVisible}
    >
      <div className="sf:relative sf:w-14 sf:h-14 sf:flex sf:items-center sf:justify-center">
        {hasUnreadAgentMessages && (
          <div className="sf:absolute sf:top-[2px] sf:right-[-2px] sf:w-4 sf:h-4 sf:bg-red-90 sf:rounded-full sf:border-2 sf:border-white sf:z-10" />
        )}

        <WidgetIcon
          isOpen={isCurrentlyVisible}
          size="lg"
          className="sf:text-widget-button-text-color"
        />
      </div>
    </button>
  );
};

export default WidgetButton;
